import React from 'react';
import PropTypes from 'prop-types';
import SingleBedIcon from '@mui/icons-material/SingleBed';
import SearchFilterUtil from 'lib/SearchFilterUtil';
import { ZERO_TO_SIX_PLUS_OPTIONS_MIN, ZERO_TO_SIX_PLUS_OPTIONS_MAX } from 'constants/filterOptions';
import useFilterStore from 'zustandStore/useFilterStore';
import RpBasicRangeFilter from 'components/commons/RpBasicRangeFilter';

const BedFilter = React.memo(function BedFilter(props) {
    const beds = useFilterStore(state => state.filters[props.comparableType].beds);
    const setFilters = useFilterStore(state => state.setFilters);

    return (
        <RpBasicRangeFilter
            label="Bed"
            displayValue={SearchFilterUtil.formatBedBathCarRangeDisplay(beds?.min, beds?.max)}
            active={!!(beds?.min || beds?.max)}
            minOptions={ZERO_TO_SIX_PLUS_OPTIONS_MIN}
            maxOptions={ZERO_TO_SIX_PLUS_OPTIONS_MAX}
            minValue={beds?.min}
            maxValue={beds?.max}
            onChange={({ min, max }) => setFilters(props.comparableType, { beds: { min: min.value, max: max.value } })}
            isDropdown={props.isDropdown}
            icon={SingleBedIcon}
        />
    );
});

BedFilter.propTypes = {
    comparableType: PropTypes.string.isRequired,
    isDropdown: PropTypes.bool
};

export default BedFilter;
